import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="flex items-center justify-center min-h-screen p-4 bg-background">
            <Card className="w-full max-w-lg text-center">
                <CardHeader className="space-y-4 pb-6">
                    <div className="flex justify-center">
                        <div className="rounded-full bg-muted p-4">
                            <AlertCircle className="h-12 w-12 text-muted-foreground" />
                        </div>
                    </div>
                    <div className="space-y-2">
                        <CardTitle className="text-6xl font-bold tracking-tight">
                            404
                        </CardTitle>
                        <CardDescription className="text-lg">
                            Page Not Found
                        </CardDescription>
                    </div>
                </CardHeader>
                <CardContent className="space-y-6">
                    <p className="text-sm text-muted-foreground max-w-md mx-auto">
                        The page you're looking for doesn't exist or has been moved. 
                        It might have been deleted or the URL might be incorrect.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
                        <Button 
                            onClick={() => navigate(-1)} 
                            variant="outline"
                            className="w-full sm:w-auto"
                        >
                            <ArrowLeft className="mr-2 h-4 w-4" />
                            Go Back
                        </Button>
                        <Button 
                            asChild
                            className="w-full sm:w-auto"
                        >
                            <Link to="/upload">
                                <Home className="mr-2 h-4 w-4" />
                                Go Home
                            </Link>
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default NotFoundPage;
